import { UPDATE_OKR_SESSION_FILTERKEY } from '../actionTypes';

const initialState = {
    status: false,
    data: {}
};

const okrSessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_OKR_SESSION_FILTERKEY:
            return {
                ...state,
                status: action.payload.status,
                data: action.payload.data
            };
        default:
            break;
    }

    return state;
};

export default okrSessionReducer;
